export default __webpack_public_path__ + "public/assets/fonts/museoSans/MuseoSans-700.woff2";